import axios from 'axios'
import { GetFoldersResponse } from '../../types/folder'
import { getExternalReference } from '../getExternalReference'

export const getFolders = async (): Promise<GetFoldersResponse | null> => {
  try {
    const backendUrl = process.env.REACT_APP_BACKEND

    if (!backendUrl) {
      console.error('REACT_APP_BACKEND environment variable is not defined')
      return null
    }

    const token = localStorage.getItem('@realize: accessToken')
    if (!token) {
      console.error('No authorization token found')
      return null
    }

    const externalReference = getExternalReference(backendUrl)

    const response = await axios.get(`${backendUrl}/n8n/mavis/folders`, {
      params: {
        external_reference: externalReference
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    })

    return (response.data as unknown) as GetFoldersResponse
  } catch (error) {
    console.error('Unexpected error:', error)
    return null
  }
}
